import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';

import { StyledScrollInfo, StyledScrollInfoText } from './styles';

export const ScrollInfo = () => {
  const { t } = useTranslation();
  return (
    <StyledScrollInfo data-automation="ScrollInfo">
      <SWReactIcons iconName="social-linkedin" size="sm" />
      <StyledScrollInfoText data-automation="ScrollInfoText">{t('contacts.scroll_info')}</StyledScrollInfoText>
    </StyledScrollInfo>
  );
};
